export default "__VITE_ASSET__B5wThi1v__"